import {ChangeEvent, useCallback, useState} from "react";

type ChangeHandler = (event: ChangeEvent<HTMLInputElement>) => void;

export function useFormTextInput(defaultValue?: string): [string, ChangeHandler, () => void] {
    const [value, setValue] = useState<string>(defaultValue || "");

    const handleInputChange = useCallback(({target}) => setValue(target.value), []);

    const reset = useCallback(() => setValue(""), []);

    return [value, handleInputChange, reset];
}
